import { render, staticRenderFns } from "./MaterialDidactico.vue?vue&type=template&id=de5d9c64&"
import script from "./MaterialDidactico.vue?vue&type=script&lang=js&"
export * from "./MaterialDidactico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports